import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type GameState = {
  avatarFileName: string | undefined;
  setAvatarFileName: (avatarFileName: string | undefined) => void;
};

const useGameStore = create<GameState>()(
  persist(
    (set) => ({
        avatarFileName: undefined, 
        setAvatarFileName: (avatarFileName: string | undefined) => set({ avatarFileName }),
    }),
    {
      name: 'game-storage',
    }
  )
);

export default useGameStore;
